export const CITIES = ["London", "Manchester", "Liverpool", "Birmingham", "Glasgow", "Other UK"];
export const DISCIPLINES = ["Boxing", "Muay Thai", "MMA", "BJJ"];
export const STANCES = ["Orthodox", "Southpaw", "Switch"];
export const LEVELS = ["Amateur", "Pro", "Hobbyist"];
export const FIGHT_STATUS = ["Active", "Fight Booked", "Off-Season", "Injured"];
export const WORK_TYPES = ["Hard Sparring", "Technical/Flow Sparring", "Padwork/Clinch"];
export const GOVERNING_BODIES = [
  "England Boxing",
  "UK Muay Thai Federation (UKMF)",
  "UKMMA / IMMAF",
  "UKBJJA (BJJ)",
  "Other governing body",
  "Not currently affiliated",
];

export const DISCIPLINE_COLORS = {
  Boxing: "#00FF66",
  "Muay Thai": "#FF3B30",
  MMA: "#3B82F6",
  BJJ: "#A855F7",
};
